module.exports = __webpack_public_path__ + "static/media/paypal-original.0c258362.svg";